import './modal.scss';

function Modal({...props}) {
    return (
        <div className={`modal ${props.open && 'open'}`} onClick={() => props.setOpen(false)} id={props.id}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <i className="fal fa-times" onClick={() => props.setOpen(false)}></i>
                {props.children}
            </div>
        </div>
    )
}

export { Modal };